import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export const CustomCheckbox = ({ label, checked, onChange, name,value }) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} 
      onChange={onChange} 
      name={name} 
      value={value || ""} />}
      label={label}
    />
  );
};

